import { render, staticRenderFns } from "./SelectPointGroupModal.vue?vue&type=template&id=fb877fa2"
import script from "./SelectPointGroupModal.vue?vue&type=script&lang=js"
export * from "./SelectPointGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports